import { readCookie } from "@/utils/readCookie";
import { AiFillDashboard } from "react-icons/ai";
import { BsChatSquareDotsFill } from "react-icons/bs";
import { FaUserCog, FaUsers } from "react-icons/fa";
import { FaHandshakeSimple } from "react-icons/fa6";
import { GrServices } from "react-icons/gr";
import { MdFeedback, MdShoppingCart } from "react-icons/md";
import { Link, useLocation } from "react-router-dom";
import "./sidebar.css";
import { ClipboardListIcon, HandshakeIcon, LayersIcon, LayoutDashboardIcon, MessagesSquareIcon, ShoppingCartIcon, UserCogIcon, UsersIcon } from "lucide-react";

const AdminSidebar = () => {
  const user = readCookie("user");
  const permissions = user?.permissions;
  const { pathname } = useLocation();

  return (
    <>
      <div
        className={`admin-sidebar h-[calc(100vh-96px)] glass-header z-20 sticky top-[96px]`}
      >
        <ul className="admin-ul">
          {permissions?.dashboard !== "none" && (
            <Link
              className={`admin-link ${
                pathname.includes("dashboard") && "bg-[#d5e6f6]"
              }`}
              to={"/admin/dashboard"}
            >
              <LayoutDashboardIcon className="text-muted-foreground size-6" />
              Dashboard
            </Link>
          )}

          {permissions?.categories !== "none" && (
            <Link
              className={`admin-link ${
                pathname.includes("categories") && "bg-[#d5e6f6]"
              }`}
              to={"/admin/categories"}
            >
              <LayersIcon className="text-muted-foreground size-6" />
              Categories
            </Link>
          )}

          {permissions?.serviceRequests !== "none" && (
            <Link
              className={`admin-link ${
                pathname.includes("serviceRequests") && "bg-[#d5e6f6]"
              }`}
              to={"/admin/serviceRequests"}
            >
              <ClipboardListIcon className="text-muted-foreground size-6" />
              Service Requests
            </Link>
          )}

          {permissions?.partners !== "none" && (
            <Link
              className={`admin-link ${
                pathname.includes("partners") && "bg-[#d5e6f6]"
              }`}
              to={"/admin/partners"}
            >
              <HandshakeIcon className="text-muted-foreground size-6" />
              Partners
            </Link>
          )}

          {permissions?.clients !== "none" && (
            <Link
              className={`admin-link ${
                pathname.includes("clients") && "bg-[#d5e6f6]"
              }`}
              to={"/admin/clients"}
            >
              <UsersIcon className="text-muted-foreground size-6" />
              Clients
            </Link>
          )}

          {permissions?.purchasedServices !== "none" && (
            <Link
              className={`admin-link ${
                pathname.includes("purchased-services") && "bg-[#d5e6f6]"
              }`}
              to={"/admin/purchased-services"}
            >
              <ShoppingCartIcon className="text-muted-foreground size-6" />
              Purchased Services
            </Link>
          )}

          {permissions?.chats !== "none" && (
            <Link
              className={`admin-link ${
                pathname.includes("chats") && "bg-[#d5e6f6]"
              }`}
              to={"/admin/chats"}
            >
              <MessagesSquareIcon className="text-muted-foreground size-6" />
              Chats
            </Link>
          )}

          {permissions?.subAdmins !== "none" && (
            <Link
              className={`admin-link ${
                pathname.includes("subAdmins") && "bg-[#d5e6f6]"
              }`}
              to={"/admin/subAdmins"}
            >
              <UserCogIcon className="text-muted-foreground size-6" />
              Sub Admins
            </Link>
          )}
        </ul>
      </div>
    </>
  );
};

export default AdminSidebar;
